import { useEffect, useState } from "react";

import { B2GO_PROMO_START, isB2GOPromoActive } from "constants/influencer";

export type SalePhase = "pre" | "live" | "ended";

export const getSalePhase = (): SalePhase => {
  if (Date.now() < B2GO_PROMO_START.getTime()) {
    return "pre";
  }
  if (isB2GOPromoActive()) {
    return "live";
  }
  return "ended";
};

interface Countdown {
  days: number;
  hrs: number;
  mins: number;
  secs: number;
}

export const useCountdown = (target: Date): Countdown => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, target.getTime() - now);
  return {
    days: Math.floor(diff / 86400000),
    hrs: Math.floor((diff % 86400000) / 3600000),
    mins: Math.floor((diff % 3600000) / 60000),
    secs: Math.floor((diff % 60000) / 1000),
  };
};
